import React from "react";
import GoogleMap from "../components/GoogleMap";

import "./Map.css";

const Map = ({ multipleMaps, cssClass }) => {
  const defaultClassName = cssClass
    ? ["module module__map", cssClass].join(" ")
    : `module module__map`;

  const getInfoWindowString = (marker) => `
    <div>
      <div style="font-size: 16px;">
        ${marker.title}<br>${marker.description}
      </div>
    </div>`;

  // Return map bounds based on list of places
  const getMapBounds = (map, maps, markers) => {
    const bounds = new maps.LatLngBounds();
    markers.forEach((marker) => {
      bounds.extend(
        new maps.LatLng(marker.location.latitude, marker.location.longitude)
      );
    });
    return bounds;
  };

  // Re-center map when resizing the window
  const bindResizeListener = (map, maps, bounds) => {
    maps.event.addDomListenerOnce(map, "idle", () => {
      maps.event.addDomListener(window, "resize", () => {
        map.fitBounds(bounds);
      });
    });
  };

  // Fit map to its bounds after the api is loaded
  const apiIsLoaded = (map, maps, markers) => {
    const pins = [];
    const infowindows = [];
    markers.forEach((marker) => {
      // Add pins to map
      pins.push(
        new maps.Marker({
          position: {
            lat: marker.location.latitude,
            lng: marker.location.longitude,
          },
          map,
        })
      );
      // Add infowindows to pins
      infowindows.push(
        new maps.InfoWindow({
          content: getInfoWindowString(marker),
        })
      );
    });
    // Add event listener to pin to open infowindow
    pins.forEach((pin, i) => {
      pin.addListener("click", () => {
        infowindows[i].open(map, pin);
      });
    });
    // Fit map to markers only if we have multiple markers
    if (markers.length > 1) {
      // Get bounds by our places
      let bounds = getMapBounds(map, maps, markers);
      // Fit map to bounds
      map.fitBounds(bounds);
      // Bind the resize listener
      bindResizeListener(map, maps, bounds);
    }
  };

  let markers = multipleMaps;
  let zoom = multipleMaps[0].location.zoom;
  let center = {
    lat: multipleMaps[0].location.latitude,
    lng: multipleMaps[0].location.longitude,
  };

  return (
    <div className={defaultClassName}>
      <div className="module__box">
        <GoogleMap
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps, markers)}
          defaultCenter={center}
          defaultZoom={Number(zoom)}
        />
      </div>
    </div>
  );
};

export default Map;
